import { Component, OnInit, Input, Output, EventEmitter, SimpleChange, forwardRef } from '@angular/core';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { VehicleService } from '../../../services/vehicle.service';
import { CACHE_KEYS } from '../../../contants/CACHE_KEYS';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'ztsi-vehicle-select',
	templateUrl: './ztsi-vehicle-select.component.html',
	styleUrls: ['./ztsi-vehicle-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiVehiclePickerComponent),
			multi: true
		}
	]
})
export class ZtsiVehiclePickerComponent implements ControlValueAccessor {
	vehicles: KeyValuePair[] = [];

	@Input() isDisabled: boolean = false;
	@Input('value') _value: string;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _vehicleService: VehicleService
	) { }	

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	

	ngOnInit() {
		this._vehicleService.getVehiclesDropdownList().subscribe(response => {
			if (response.length != undefined) {
				this.vehicles = response;
			}
			else {
				console.log('Unable to load vehicle selection.');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-vehicle-select/ztsi-vehicle-select.component.ts